import { createRoot, type Root } from "react-dom/client";
import NextGen from "../pages/NextGen/NextGen";
import "../index.css";
import "../pages/NextGen/NextGen.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<NextGen />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADNextGen = { mount, unmount };

function boot() {
  const element = document.getElementById("next-gen-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
